export default __webpack_public_path__ + "static/media/gw200-1.5c4aaa39.png";